import * as basicLightbox from 'basiclightbox';
import 'basiclightbox/dist/basicLightbox.min.css';

import { modalDescriptions } from './modalDescriptions.js';
import { generateModalHTML } from './templateModalDescriptions.js';

document.querySelectorAll('.btn-more').forEach(btn => {
  btn.addEventListener('click', () => {
    const key = btn.dataset.service;
    const data = modalDescriptions[key];
    const html = generateModalHTML(data);

    const instance = basicLightbox.create(html, {
      onShow: instance => {
        // Заборона скролу
        document.body.classList.add('no-scroll');

        // Обробка кнопок закриття
        const closeButtons = instance
          .element()
          .querySelectorAll('.modal-close');
        closeButtons.forEach(el =>
          el.addEventListener('click', () => instance.close())
        );
      },
      onClose: () => {
        // Повернення скролу
        document.body.classList.remove('no-scroll');
      },
    });

    instance.show();
  });
});
